import Vue from 'vue';
import Router from 'vue-router';
import i18n from '../i18n';

import XmlChannelStatus from '../pages/XmlChannelStatus';
import Dashboard from '../pages/Dashboard';
import PageNotFound from '../pages/error-pages/PageNotFound';
import Schedules from '../pages/Schedules';
import EditSchedules from '../pages/EditSchedules';
import Requests from '../pages/Requests';
import Prices from '../pages/Prices';

import { session } from './middleware';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
      meta: {
        title: i18n.t('menu.dashboard.title'),
      },
    },
    {
      path: '/xml-channel-status',
      name: 'XmlChannelStatus',
      component: XmlChannelStatus,
      meta: {
        title: i18n.t('menu.xmlChannelStatus.title'),
      },
    },
    {
      path: '/schedules',
      name: 'Schedules',
      component: Schedules,
      meta: {
        title: i18n.t('menu.schedules.title'),
      },
    },
    {
      path: '/schedules/edit/:webservice',
      name: 'EditSchedules',
      component: EditSchedules,
      meta: {
        title: i18n.t('menu.schedules.title'),
      },
    },
    {
      path: '/requests',
      name: 'Requests',
      component: Requests,
      meta: {
        title: i18n.t('menu.requests.title'),
      },
    },
    {
      path: '/prices',
      name: 'Prices',
      component: Prices,
      meta: {
        title: i18n.t('menu.prices.title'),
      },
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        title: i18n.t('menu.pageNotFound.title'),
      },
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'XML Stats';
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js